import { type ImperativePanelHandle, Panel } from 'react-resizable-panels'

export const ResizablePanel = Panel

export type ImperativeResizablePanelHandle = ImperativePanelHandle
